export default __webpack_public_path__ + "static/media/CheckedRadioButton.85cdff81.svg";